import React from 'react';
import { Routes, Route } from 'react-router-dom';

// Import page components
import { LocationsPage } from './pages/LocationsPage';
import { LocationDetailPage } from './pages/LocationDetailPage';

export const LocationRoutes: React.FC = () => {
  return (
    <Routes>
      <Route index element={<LocationsPage />} />
      <Route path=":id" element={<LocationDetailPage />} />
    </Routes>
  );
};

export default LocationRoutes;
